import { Heading } from "@chakra-ui/react";
import UploadImage from "../UploadImage";
import { useAuth } from "../contexts/AuthContext";

export default function UploadImagePage() {
  const { currentUser } = useAuth();
  return (
    <>
      {/*<Heading>Upload gonna be happen here</Heading>*/}
      {currentUser && <UploadImage />}
    </>
  );
}
